exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header1{\n    width: 98%;\n    margin: 20px auto;\n    padding: 10px 0 10px 30px;\n    background: #3cd4f4;\n    color: #EAEAEA;\n    border-radius: 3px;\n    font-size: 24px;\n}\n.edit-button{\n    float: right;\n    font-size: 19px;\n    font-weight: bold;\n    background: #00d2f1;\n}\n.edit-button:hover{\n    color:#7c7c7c;\n    background:#ededee;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/users/investor/edituser/investor-edit-user.component.css
// module id = ../../../../../src/app/components/pages/users/investor/edituser/investor-edit-user.component.css
// module chunks = main